module.exports = __webpack_public_path__ + "static/media/coding.a2c7f965.png";